"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconHome = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M54.28 34.46a1.63 1.63 0 0 0-1.66 1.66v22.66H40.87v-9.25a1.64 1.64 0 0 0-1.6-1.63h-8.5a1.68 1.68 0 0 0-1.69 1.63v9.25H17.35V36.87a1.63 1.63 0 0 0-3.25 0v23.57a1.61 1.61 0 0 0 1.6 1.6h15.07a1.61 1.61 0 0 0 1.59-1.6v-9.25h5.25v9.25A1.63 1.63 0 0 0 39.27 62h15a1.61 1.61 0 0 0 1.6-1.6V36.12a1.62 1.62 0 0 0-1.6-1.66zm0 0"
  }), _react["default"].createElement("path", {
    d: "M63.29 35.75L50.21 22.61v-9A1.66 1.66 0 0 0 48.52 12a1.62 1.62 0 0 0-1.6 1.66v5.67L36.13 8.47A1.58 1.58 0 0 0 35 8a1.62 1.62 0 0 0-1.17.52L6.74 35.57a1.55 1.55 0 0 0 0 2.29 1.55 1.55 0 0 0 2.29 0L35 11.94l25.94 26.17a1.6 1.6 0 0 0 1.17.42 1.83 1.83 0 0 0 1.18-.42 1.71 1.71 0 0 0 0-2.36zm0 0"
  })),
  height: undefined,
  width: undefined
});
IconHome.displayName = 'IconHome';
var _default = IconHome;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/home.js
// module id = 332
// module chunks = 0